import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import Editor from '../shared/skyckeditor';
import { Modal } from 'react-bootstrap';
import { template } from 'handlebars';
import CreateTemplateModal from './emailtemplate-create-modal';
import Notifications from '../utils/notification-helper';  
import ConfirmModal from '../shared/confirm-modal';

@inject('appStore')
@observer
export default class EmailTemplatesView extends Component {
    state = {
        readyForChanges: false,
        templateDraft: undefined,
        saving: false,
        deleting:false,
        changeName:false,
        message: '',
        newName:'',
        deleteModal: false,
        isInvalid: true
    };

    onTemplateSelected = (templateId) => {
        const { emailTemplateStore } = this.props.appStore;
        let template = emailTemplateStore.templates.find((t) => t.id === templateId);
        if (template) {
            template = JSON.parse(JSON.stringify(template));
        }
        this.setState({ templateDraft: template, readyForChanges: true, newName: template.name, saving: false});
    };

    onDraftModified = (key, value) => {
        if (this.state.readyForChanges) {
            this.setState({ templateDraft: { ...this.state.templateDraft, [key]: value, modified: true } });
        }
        
        this.validateFields();
    };

    validateFields()
    {
        if(this.state.templateDraft.body==undefined || this.state.templateDraft.body=='' )
        {
            return false;
        }
        
        if(this.state.templateDraft.subject==undefined || this.state.templateDraft.subject=='' )
        {
            return false;
        }
            return true;
    }
    onSaveTemplate = async () => {
        if(this.validateFields())
        {
        const template = { ...this.state.templateDraft };
        delete template.modified;
        this.setState({ saving: true });
        await this.props.appStore.emailTemplateStore.saveTemplate(template);
        Notifications.ToastSuccess('Template has been saved');
        this.setState({ saving: false});
     }
    };

    onDeleteTemplate = async () => {
        const template = { ...this.state.templateDraft };
        this.setState({ deleting: true });
        template.isdeleted = true;
        await this.props.appStore.emailTemplateStore.saveTemplate(template);
        //await this.props.appStore.emailTemplateStore.deleteTemplate(template);
        this.setState({ deleteModal: false, templateDraft:null});
        this.props.appStore.viewStore.openEmailTemplatesPage(); //Reload templates 
        Notifications.ToastSuccess('Template has been deleted');
    };

    onChangeName = () => {
        let template = this.props.appStore.emailTemplateStore.templates.find((t) => t.id ===  this.state.templateDraft.id);
        this.setState({changeName: !this.state.changeName, newName: template.name });

    };
    onDeleteModal = () => {
        this.setState({deleteModal: !this.state.deleteModal });

    };
    onNewNameChange = (e) => {

        this.setState({newName:e.target.value});
       
    };

    handleChangeName = async () => {
       
        const template = { ...this.state.templateDraft };
        template.name =  this.state.newName;
        await this.props.appStore.emailTemplateStore.saveTemplate(template);
        this.setState({ changeName: false });
        this.props.appStore.viewStore.openEmailTemplatesPage(); //Reload templates        
        this.onTemplateSelected(this.state.templateDraft.id);
        Notifications.ToastSuccess('Template has been saved');

    };
    render() {
        const { emailTemplateStore } = this.props.appStore;
        const { templateDraft, readyForChanges } = this.state;

        const styledPreview = templateDraft
            ? emailTemplateStore.inlineContent(templateDraft.body, emailTemplateStore.style.css)
            : null;
        return (
            <div className="tab-pane active agent-view">
                <FormGroup controlId="newTemplate">
                 <button
                                className="btn btn-primary"
                                onClick={appStore.viewStore.createTemplateDialogModal}
                                style={{ marginRight: 10 }}
                            >
                                New Template
                </button>
                <button
                                disabled={!templateDraft}
                                className="btn btn-danger"
                                onClick={this.onDeleteModal}
                                style={{ marginRight: 10 }}
                            >
                                 Delete
                </button>
                
                <button
                                disabled={!templateDraft}
                                className="btn btn-primary"
                                onClick={this.onChangeName}
                            >
                                Change Name
                     </button>
               </FormGroup>
                <FormGroup controlId="templateSelect">
                    <ControlLabel>Template</ControlLabel>
                    <FormControl
                        componentClass="select"
                        value={templateDraft ? templateDraft.id : -1}
                        onChange={(e) => this.onTemplateSelected(+e.target.value)}
                    >
                        <option disabled value={-1}>
                            Select a template
                        </option>
                        {emailTemplateStore.templates.map((t) => (
                            <option key={t.id} value={t.id}>
                                {t.name} ({t.settings.tags.join(', ')})
                            </option>
                        ))}
                    </FormControl>
                </FormGroup>
                {templateDraft && (
                    <div>
                        <FormGroup controlId="templateSubject" key={templateDraft.id}>
                            <ControlLabel>Subject</ControlLabel>
                            <FormControl
                                type="text"
                                defaultValue={templateDraft.subject}
                                onChange={(e) => this.onDraftModified('subject', e.target.value)}
                            />
                          { (templateDraft.subject==undefined ||templateDraft.subject=='' || templateDraft.subject=="") && (
                         <p className="form-error" >The Subject field is required</p>
                          )}
                        </FormGroup>
                        <label>Email Body</label>
                        <Editor
                            container="editable"
                            editorId="template-edit"
                            uniqueKeyFromProps={`template-edit-${templateDraft.id}`}
                            data={templateDraft.body}
                            onReady={() => {
                                this.setState({ readyForChanges: true });
                            }}
                            handleFormChange={_.debounce(
                                () => {
                                    if (readyForChanges) {
                                        const data = CKEDITOR.instances['template-edit'].getData();
                                        this.onDraftModified('body', data);
                                    }
                                },
                                1500,
                                { maxWait: 3000 }
                            )}
                        />
                       { (templateDraft.body==undefined || templateDraft.body=='' || templateDraft.body=="") && (
                           <p className="form-error" >The Body field is required</p>
                          )}

                        <button
                            className="btn btn-primary"
                            disabled={templateDraft.subject==undefined ||templateDraft.subject=='' ||
                                       templateDraft.body==undefined ||templateDraft.body=='' ||
                                     this.state.saving || !templateDraft.modified}
                            onClick={this.onSaveTemplate}
                        >
                            {this.state.saving ? ' Saving...' : 'Save Template'}
                        </button>
                        {this.state.message && <div>{this.state.message}</div>}
                    </div>
                )}
                {styledPreview && (
                    <div style={{ marginTop: 32 }}>
                        <label>Preview with Style</label>
                        <div
                            style={{ border: '1px solid #ddd', padding: 8 }}
                            dangerouslySetInnerHTML={{ __html: styledPreview }}
                        />
                    </div>
                )}
                 <Modal
                    show={this.state.changeName}
                    onHide={this.onChangeName}
                 >
                <Modal.Header closeButton>
                    <Modal.Title id="">Change name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                      <label>New name: </label><input className="form-control"  value={this.state.newName} onChange={this.onNewNameChange.bind(this)}/>
                  
                    <button
                            className="btn btn-success"
                            disabled={this.state.newName==''}
                            onClick={this.handleChangeName}
                            style={{marginTop: 30}}
                        >
                            Change name
                     </button>
                </Modal.Body>
            </Modal>
            <CreateTemplateModal />
            <ConfirmModal
                    show={this.state.deleteModal}
                    onHide={this.onDeleteModal}
                    onConfirmed={this.onDeleteTemplate}
                    headerText={'Delete Template'}
                    buttonType={'btn-danger'}
                    bodyText={'Are you sure you want to delete this Template?'}
                    buttonText={'Confirm Delete Template'}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/template/emailtemplates-view.js